import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../constants/colors";

export default makeStyles((theme) => ({
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  productMainInfo: {
    padding: 10,
    height: "100%",
  },
  productMainInfoPaper: {
    backgroundColor: `${COLORS.accent}`,
    fontFamily: "Blinker",
    padding: "10px 20px",
    marginTop: "10px",
    marginBottom: "20px",
  },
  gridContainer: {
    width: "100%",
    margin: "0",
    animation: "$displayProductInfo 2s 1 forwards"
  },
  image: {
    height: "300px",
  },
  productName: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Montserrat",
    fontSize: "20px",
  },
  productViewCount: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0px",
  },
  header: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    padding: "5px 5px",
  },
  productOldPrice: {
    padding: "0 10px",
    textDecoration: "line-through",
  },
  productNewPrice: {
    padding: "0 10px",
    fontWeight: "bold",
    fontSize: "22px"
  },
  productDiscount: {
    padding: "0 10px",
    fontWeight: "bold",
    fontSize: "18px"
  },
  productViewCountText: {
    padding: "0 10px",
    fontSize: "16px"
  },
  productDescriptionContainer: {
    padding: "5px",
  },
  productPromoCodeText: {
    fontSize: 18,
    fontWeight: 700
  },
  productDescription: {
    fontFamily: "Blinker",
    fontSize: "18px",
    paddingTop: "15px",
    paddingRight: "25px",
  },
  disclaimer: {
    fontFamily: "Blinker",
    fontSize: "18px",
    padding: "15px",
  },
  buyOnAmazon: {
    width: "75%",
    backgroundColor: `${COLORS.amazonColor}`,
    color: "black",
    "&:hover": {
      backgroundColor: `${COLORS.amazonDarkColor}`,
    },
  },
  divider: {
    height: "1px",
    backgroundColor: "black",
  },
  loaderContainer: {
    height: "65vh",
  },
  loader: {
    color: `${COLORS.accent}`,
  },
  "@keyframes displayProductInfo": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
